$wj([14],{

/***/ 1561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function findPeopleJsonRequest(data) {
    var result = tslib_1.__assign({ __type: 'FindPeopleJsonRequest:#Exchange' }, data);
    return result;
}
exports.default = findPeopleJsonRequest;


/***/ }),

/***/ 1610:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var addNotification_1 = __webpack_require__(1614);
exports.addNotification = addNotification_1.default;
var NotificationToast_1 = __webpack_require__(1615);
exports.NotificationToast = NotificationToast_1.default;
var NotificationViewState_1 = __webpack_require__(369);
exports.NotificationActionType = NotificationViewState_1.NotificationActionType;
var store_1 = __webpack_require__(366);
exports.headerToastNotificationStore = store_1.default;
var notificationHandler_1 = __webpack_require__(368);
exports.ensureNotificationHandlerRegistered = notificationHandler_1.ensureNotificationHandlerRegistered;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1614:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var legacy_1 = __webpack_require__(1);
var store_1 = __webpack_require__(366);
var nextId = 0;
exports.default = legacy_1.action('addNotification')(function addNotification(notificationViewState) {
    var notification = tslib_1.__assign({ id: nextId++ }, notificationViewState);
    store_1.default.notificationViewStates.push(notification);
});
//# sourceMappingURL=addNotification.js.map

/***/ }),

/***/ 1615:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var SkypeToast_1 = __webpack_require__(1616);
var WarningToast_1 = __webpack_require__(1619);
var NotificationViewState_1 = __webpack_require__(369);
var mobx_react_1 = __webpack_require__(11);
var React = __webpack_require__(3);
var NotificationToast = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationToast, _super);
    function NotificationToast() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificationToast.prototype.render = function () {
        var notification = this.props.notification;
        switch (notification.actionType) {
            case NotificationViewState_1.NotificationActionType.SkypeNotification:
                return React.createElement(SkypeToast_1.default, { notification: notification });
            default:
                return React.createElement(WarningToast_1.default, { notification: notification });
        }
    };
    NotificationToast = tslib_1.__decorate([
        mobx_react_1.observer
    ], NotificationToast);
    return NotificationToast;
}(React.Component));
exports.default = NotificationToast;
//# sourceMappingURL=NotificationToast.js.map

/***/ }),

/***/ 1616:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var BaseToast_1 = __webpack_require__(642);
var removeNotification_1 = __webpack_require__(367);
var updateNotificationIgnore_1 = __webpack_require__(1617);
var notificationHandler_1 = __webpack_require__(368);
var mobx_react_1 = __webpack_require__(11);
var React = __webpack_require__(3);
var styles = __webpack_require__(643);
var classNames = __webpack_require__(30);
var SkypeToast = /** @class */ (function (_super) {
    tslib_1.__extends(SkypeToast, _super);
    function SkypeToast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onCancelClick = function (e) {
            e.stopPropagation();
            updateNotificationIgnore_1.default(_this.props.notification, true);
            notificationHandler_1.handleNotification(_this.props.notification);
            _this.onNotificationRemoved();
        };
        _this.onNotificationRemoved = function () {
            if (_this.timer) {
                clearTimeout(_this.timer);
                _this.timer = null;
            }
        };
        return _this;
    }
    SkypeToast.prototype.render = function () {
        var _a = this.props
            .notification, title = _a.title, description = _a.description, actionLink = _a.actionLink, cancelLink = _a.cancelLink;
        // UX is still being decided
        return (React.createElement("div", { className: styles.toast, onClick: this.onActionClick },
            React.createElement("div", { className: styles.iconContainer }, this.renderImage()),
            React.createElement("div", { className: styles.toastInfo },
                React.createElement("div", { className: classNames(styles.title, styles.ellipsisOverflow) }, title),
                React.createElement("div", { className: classNames(styles.description, styles.ellipsisOverflow) }, description),
                React.createElement("div", { className: styles.linksContainer },
                    React.createElement("div", null, actionLink),
                    cancelLink && (React.createElement("div", { className: styles.closeLink, onClick: this.onCancelClick }, cancelLink))))));
    };
    SkypeToast.prototype.componentDidMount = function () {
        var _this = this;
        var displayTime = this.props.notification.displayTime;
        if (displayTime) {
            this.timer = setTimeout(function () {
                removeNotification_1.default(_this.props.notification);
                _this.timer = null;
            }, displayTime);
        }
    };
    SkypeToast.prototype.renderImage = function () {
        return (React.createElement("span", null,
            React.createElement("img", { className: styles.imageCircle, src: this.props.notification.image })));
    };
    SkypeToast = tslib_1.__decorate([
        mobx_react_1.observer
    ], SkypeToast);
    return SkypeToast;
}(BaseToast_1.default));
exports.default = SkypeToast;
//# sourceMappingURL=SkypeToast.js.map

/***/ }),

/***/ 1617:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('updateNotificationIgnore')(function updateNotificationIgnore(notification, ignore) {
    notification.ignore = ignore;
});
//# sourceMappingURL=updateNotificationIgnore.js.map

/***/ }),

/***/ 1618:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._2gzLNvb4XYt738rt_Y9R7K{width:370px;font-weight:400;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-timing-function:cubic-bezier(.1,.9,.2,1);-webkit-animation-fill-mode:both;animation-fill-mode:both;display:-webkit-box;display:-ms-flexbox;display:flex;cursor:pointer}html[dir] ._2gzLNvb4XYt738rt_Y9R7K{-webkit-box-shadow:0 0 15px -5px \"[theme:blackTranslucent40, default:rgba(0, 0, 0, .4)]\";box-shadow:0 0 15px -5px \"[theme:blackTranslucent40, default:rgba(0, 0, 0, .4)]\";border:1px solid \"[theme:neutralLight, default:#eaeaea]\";background-color:\"[theme:white, default:#ffffff]\";padding:10px}html[dir=ltr] ._2gzLNvb4XYt738rt_Y9R7K{margin:10px 10px 10px 0}html[dir=rtl] ._2gzLNvb4XYt738rt_Y9R7K{margin:10px 0 10px 10px}.w6bfiuQYw7xoLxkX8Evnp{font-size:13px;font-weight:400;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:distribute;justify-content:space-around}html[dir=ltr] .w6bfiuQYw7xoLxkX8Evnp{padding-left:12px}html[dir=rtl] .w6bfiuQYw7xoLxkX8Evnp{padding-right:12px}._27CFNmcWWrvaY_iWR_x0Qh{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.uKwLbP7ac0fNZ5umzCWeZ{width:32px;height:32px;line-height:32px;display:block}html[dir] .uKwLbP7ac0fNZ5umzCWeZ{border-radius:70%;padding:5px;text-align:center}html[dir] ._2gVRUXuKv6shS76NAvy-6V{background:#a80000}._13QbDWLYcb5y5CJyjqS3Ue{font-size:22px;color:\"[theme:white, default:#ffffff]\";position:relative;top:-1px}html[dir=ltr] ._13QbDWLYcb5y5CJyjqS3Ue{left:1px}html[dir=rtl] ._13QbDWLYcb5y5CJyjqS3Ue{right:1px}.O7zSseLtHH6zg_MKDv5gh{font-weight:600;color:\"[theme:themeDark, default:#0D62AA]\";display:block}html[dir] .O7zSseLtHH6zg_MKDv5gh{padding-bottom:1px}._3BWXJcheudt_z-c31kuSv0{color:#a80000}._3RqD5IyBZOP6QY6fQK4ibC{color:\"[theme:neutralPrimaryAlt, default:#3c3c3c]\";display:block}html[dir] ._3RqD5IyBZOP6QY6fQK4ibC{padding-top:10px}.XkwefYF7D5qWUtGklFtBm{display:-webkit-box;display:-ms-flexbox;display:flex;color:\"[theme:themePrimary, default:#0078D7]\"}html[dir] .XkwefYF7D5qWUtGklFtBm{padding-top:10px}html[dir=ltr] .my4_hmCrwIttXTGKjYJu0{padding-left:7px}html[dir=rtl] .my4_hmCrwIttXTGKjYJu0{padding-right:7px}._59Loq73PCvUbyEYNE7eI0{width:290px;text-overflow:ellipsis;white-space:nowrap;overflow-x:hidden}", ""]);

// exports
exports.locals = {
	"toast": "_2gzLNvb4XYt738rt_Y9R7K",
	"toastInfo": "w6bfiuQYw7xoLxkX8Evnp",
	"iconContainer": "_27CFNmcWWrvaY_iWR_x0Qh",
	"imageCircle": "uKwLbP7ac0fNZ5umzCWeZ",
	"warningIconCircle": "_2gVRUXuKv6shS76NAvy-6V",
	"warningIcon": "_13QbDWLYcb5y5CJyjqS3Ue",
	"title": "O7zSseLtHH6zg_MKDv5gh",
	"warningTitle": "_3BWXJcheudt_z-c31kuSv0",
	"description": "_3RqD5IyBZOP6QY6fQK4ibC",
	"linksContainer": "XkwefYF7D5qWUtGklFtBm",
	"closeLink": "my4_hmCrwIttXTGKjYJu0",
	"ellipsisOverflow": "_59Loq73PCvUbyEYNE7eI0"
};

/***/ }),

/***/ 1619:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var BaseToast_1 = __webpack_require__(642);
var mobx_react_1 = __webpack_require__(11);
var Icon_1 = __webpack_require__(43);
var React = __webpack_require__(3);
var styles = __webpack_require__(643);
var classNames = __webpack_require__(30);
var WarningToast = /** @class */ (function (_super) {
    tslib_1.__extends(WarningToast, _super);
    function WarningToast() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WarningToast.prototype.render = function () {
        var _a = this.props.notification, title = _a.title, description = _a.description, actionLink = _a.actionLink, cancelLink = _a.cancelLink;
        return (React.createElement("div", { className: styles.toast, onClick: this.onActionClick },
            React.createElement("div", { className: styles.iconContainer },
                React.createElement("span", { className: classNames(styles.warningIconCircle, styles.imageCircle) },
                    React.createElement(Icon_1.Icon, { className: styles.warningIcon, iconName: "Warning" /* Warning */ }))),
            React.createElement("div", { className: styles.toastInfo },
                React.createElement("div", { className: styles.warningTitle }, title),
                React.createElement("div", { className: styles.description }, description),
                React.createElement("div", { className: styles.linksContainer },
                    React.createElement("div", null, actionLink),
                    cancelLink && (React.createElement("div", { className: styles.closeLink, onClick: this.onCancelClick }, cancelLink))))));
    };
    WarningToast = tslib_1.__decorate([
        mobx_react_1.observer
    ], WarningToast);
    return WarningToast;
}(BaseToast_1.default));
exports.default = WarningToast;
//# sourceMappingURL=WarningToast.js.map

/***/ }),

/***/ 1748:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function findPeopleRequest(data) {
    var result = tslib_1.__assign({ __type: 'FindPeopleRequest:#Exchange' }, data);
    return result;
}
exports.default = findPeopleRequest;


/***/ }),

/***/ 1749:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function personaResponseShape(data) {
    var result = tslib_1.__assign({ __type: 'PersonaResponseShape:#Exchange' }, data);
    return result;
}
exports.default = personaResponseShape;


/***/ }),

/***/ 1750:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var findPeopleJsonRequest_1 = __webpack_require__(1561);
function findPeopleOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = findPeopleJsonRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("FindPeople", req, options);
}
exports.default = findPeopleOperation;


/***/ }),

/***/ 1901:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var addFavoriteFolder_1 = __webpack_require__(3330);
exports.addFavoriteFolder = addFavoriteFolder_1.default;
var migrateFavorites_1 = __webpack_require__(4645);
exports.migrateFavorites = migrateFavorites_1.default;
var markFavoritePersonaNodeAsAdded_1 = __webpack_require__(4646);
exports.markFavoritePersonaNodeAsAdded = markFavoritePersonaNodeAsAdded_1.default;
var moveFavoriteToPosition_1 = __webpack_require__(4647);
exports.moveFavoriteToPosition = moveFavoriteToPosition_1.default;
var moveFavoriteUpDown_1 = __webpack_require__(4648);
exports.moveFavoriteUpDown = moveFavoriteUpDown_1.default;
var onFavoritePersonaSelected_1 = __webpack_require__(4649);
exports.onFavoritePersonaSelected = onFavoritePersonaSelected_1.default;
var onSelectedPersonaNodeChanged_1 = __webpack_require__(4651);
exports.onSelectedPersonaNodeChanged = onSelectedPersonaNodeChanged_1.default;
var removeFavoritePersona_1 = __webpack_require__(3657);
exports.removeFavoritePersona = removeFavoritePersona_1.default;
var toggleFavoritePersona_1 = __webpack_require__(4652);
exports.toggleFavoritePersona = toggleFavoritePersona_1.default;
var handleToggleFavoritePersonaError_1 = __webpack_require__(4654);
exports.handleToggleFavoritePersonaError = handleToggleFavoritePersonaError_1.default;
var addFavoriteCategory_1 = __webpack_require__(3336);
exports.addFavoriteCategory = addFavoriteCategory_1.default;
var removeFavoriteCategory_1 = __webpack_require__(4655);
exports.removeFavoriteCategory = removeFavoriteCategory_1.default;
var removeFavoriteFolder_1 = __webpack_require__(4656);
exports.removeFavoriteFolder = removeFavoriteFolder_1.default;
var removeFavoriteSearch_1 = __webpack_require__(4657);
exports.removeFavoriteSearch = removeFavoriteSearch_1.default;
var toggleFavoritesTreeExpansion_1 = __webpack_require__(4658);
exports.toggleFavoritesTreeExpansion = toggleFavoritesTreeExpansion_1.default;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 2654:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function contextProperty(data) {
    var result = tslib_1.__assign({ __type: 'ContextProperty:#Exchange' }, data);
    return result;
}
exports.default = contextProperty;


/***/ }),

/***/ 2668:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var favoriteNodeParser = __webpack_require__(377);
var updateFavoritesUserOptionService_1 = __webpack_require__(3331);
var owa_mail_favorites_store_1 = __webpack_require__(32);
var getUserConfiguration_1 = __webpack_require__(9);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('updateFavoritesUserOption')(legacy_1.select({
    favoritesFolderNodes: function () { return owa_mail_favorites_store_1.favoritesStore.favoritesFolderNodes; },
    favoritesPersonaNodes: function () { return owa_mail_favorites_store_1.favoritesStore.favoritesPersonaNodes; },
    favoriteSearches: function () { return owa_mail_favorites_store_1.favoritesStore.favoriteSearches; },
    favoriteCategories: function () { return owa_mail_favorites_store_1.favoritesStore.favoriteCategories; },
    orderedFavoritesNodeIds: function () { return owa_mail_favorites_store_1.favoritesStore.orderedFavoritesNodeIds; },
})(function updateFavoritesUserOption(state) {
    var favoriteNodesRaw = favoriteNodeParser.serialize(state.orderedFavoritesNodeIds, state.favoritesFolderNodes, state.favoritesPersonaNodes, state.favoriteSearches, state.favoriteCategories);
    // Update the local user configuration store
    getUserConfiguration_1.default().UserOptions.FavoriteNodes = favoriteNodesRaw;
    // Service request to update user options for FavoriteFolders
    return updateFavoritesUserOptionService_1.default(favoriteNodesRaw);
}));
//# sourceMappingURL=updateFavoritesUserOption.js.map

/***/ }),

/***/ 3020:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function updateFavoriteFolderRequest(data) {
    var result = tslib_1.__assign({ __type: 'UpdateFavoriteFolderRequest:#Exchange' }, data);
    return result;
}
exports.default = updateFavoriteFolderRequest;


/***/ }),

/***/ 3164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var folder_1 = __webpack_require__(647);
var folderId_1 = __webpack_require__(47);
var updateFavoriteFolderRequest_1 = __webpack_require__(3020);
var updateFavoriteFolderOperation_1 = __webpack_require__(3332);
/**
 * Configure the request body for updateFavoriteFolderOperation
 * @param currentFolder the current folder to be updated
 * @param isAdd whether the operation is an add or remove operation
 */
function configureRequest(currentFolder, isAdd) {
    var targetFolderId = folderId_1.default({
        Id: currentFolder.FolderId.Id,
        ChangeKey: currentFolder.FolderId.ChangeKey,
    });
    var request = updateFavoriteFolderRequest_1.default({
        Folder: folder_1.default({
            FolderId: targetFolderId,
            DisplayName: currentFolder.DisplayName,
        }),
        Operation: isAdd ? 0 /* Add */ : 1 /* Remove */,
    });
    return request;
}
/**
 * Sends out the service request to add or remove the a favorite in favorite store
 * @param currentFolder the current folder to be updated
 * @param isAdd whether the operation is an add or remove operation
 * @return a promise that contains UpdateFavoriteFolderResponse
 */
function addRemoveFavoriteService(currentFolder, isAdd) {
    var requestBody = configureRequest(currentFolder, isAdd);
    // TODO: Task 314: Make this not throw an HTTP 500 error on the server
    return updateFavoriteFolderOperation_1.default({
        request: requestBody,
    }).then(function (response) {
        return response;
    });
}
exports.default = addRemoveFavoriteService;
//# sourceMappingURL=addRemoveFavoriteService.js.map

/***/ }),

/***/ 3165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var findPeopleByEmail_1 = __webpack_require__(3334);
var owa_trace_1 = __webpack_require__(14);
var owa_analytics_1 = __webpack_require__(12);
var datapoints_1 = __webpack_require__(237);
function getPersonaByEmail(emailAddress, displayName) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var people, contacts, response, _a, personasForDisplayName, personaToReturn;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    people = findPeopleByEmail_1.findPeopleByEmail(emailAddress);
                    return [4 /*yield*/, findPeopleByEmail_1.findContactsByEmail(emailAddress)];
                case 1:
                    contacts = _b.sent();
                    if (!(contacts.personas && contacts.personas.length > 0)) return [3 /*break*/, 2];
                    _a = contacts;
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, people];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    response = _a;
                    // We can get several hits for the given email with different displayNames, to avoid confusion for the user
                    // we use the one favorited
                    if (response.personas && response.personas.length > 0) {
                        personasForDisplayName = response.personas.filter(function (persona) { return persona.DisplayName === displayName; });
                        if (personasForDisplayName.length > 0) {
                            return [2 /*return*/, personasForDisplayName[0]];
                        }
                        personaToReturn = response.personas[0];
                        // Contact from the recipient cache without a proper displayName,
                        // fall back on the provided display name
                        if (personaToReturn.DisplayName === emailAddress &&
                            personaToReturn.EmailAddress.MailboxType === 'OneOff') {
                            owa_analytics_1.logUsage(datapoints_1.default.OneOffAddressUsedForFavorite.datapoint.name);
                            return [2 /*return*/, tslib_1.__assign({}, personaToReturn, { DisplayName: displayName })];
                        }
                        return [2 /*return*/, personaToReturn];
                    }
                    else {
                        owa_trace_1.trace.warn("Cannot find persona by email: " + emailAddress);
                        throw new Error("Persona not found (people: " + response.requestId + ", contacts: " + contacts.requestId + ", length: " + (emailAddress ? emailAddress.length : 'no email address') + ")");
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = getPersonaByEmail;
//# sourceMappingURL=getPersonaByEmail.js.map

/***/ }),

/***/ 3166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var updateFavoritesUserOption_1 = __webpack_require__(2668);
var setupFavoritePersona_1 = __webpack_require__(716);
var owa_mail_favorites_store_1 = __webpack_require__(32);
var owa_mail_persona_search_folder_services_1 = __webpack_require__(163);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('synchronizeSearchFolder')(function synchronizeSearchFolder(persona) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var state, parentFolderId, _a, searchFolderPersona, searchFolder;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    state = owa_mail_favorites_store_1.getStore();
                    _a = state.favoritePersonasRoodFolderId;
                    if (_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, owa_mail_persona_search_folder_services_1.getFavoritePersonasRootFolderId()];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    parentFolderId = _a;
                    searchFolderPersona = {
                        personaId: persona.id,
                        displayName: persona.displayName,
                        allEmailAddresses: persona.allEmailAddresses,
                    };
                    return [4 /*yield*/, owa_mail_persona_search_folder_services_1.synchronizePersonaSearchFolder(searchFolderPersona, parentFolderId)];
                case 3:
                    searchFolder = _b.sent();
                    setupFavoritePersona_1.default(searchFolder);
                    persona.isSyncUpdateDone = true;
                    if (!state.haveFavoritePersonasChanged) return [3 /*break*/, 5];
                    state.haveFavoritePersonasChanged = false;
                    return [4 /*yield*/, updateFavoritesUserOption_1.default()];
                case 4:
                    _b.sent();
                    _b.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=synchronizeSearchFolder.js.map

/***/ }),

/***/ 3330:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var updateFavoritesUserOption_1 = __webpack_require__(2668);
var addRemoveFavoriteService_1 = __webpack_require__(3164);
var store_1 = __webpack_require__(240);
var Store_1 = __webpack_require__(17);
var legacy_1 = __webpack_require__(1);
var datapoints_1 = __webpack_require__(237);
/**
 * Add a favorite node to the favorite store
 * @param idToUpdate the id to update
 * @param state the state which contains the favoritesFolderNodes and the folder to update
 */
exports.default = legacy_1.action('AddFavoriteFolder', datapoints_1.default.AddFavoriteFolder)(legacy_1.select({
    favoritesFolderNodes: function () { return store_1.default.favoritesFolderNodes; },
    orderedFavoritesNodeIds: function () { return store_1.default.orderedFavoritesNodeIds; },
    folder: function (idToUpdate, isAdd) { return Store_1.default.folders.folderTable.get(idToUpdate); },
})(function addFavoriteFolder(idToUpdate, actionSource, state) {
    // Check if favoritesFolderNodes already has the same folder id
    if (state.favoritesFolderNodes.has(idToUpdate)) {
        throw new Error('Cannot add duplicate folder to favorites.');
    }
    // Add to favorite to favorites store
    state.orderedFavoritesNodeIds.push(idToUpdate);
    state.favoritesFolderNodes.set(idToUpdate, {
        id: idToUpdate,
        type: 0 /* Folder */,
    });
    // Update user options service which is used by OWA
    updateFavoritesUserOption_1.default();
    // Service request for FAI that used by outlook desktop
    addRemoveFavoriteService_1.default(state.folder, true /* isAdd */);
}));
//# sourceMappingURL=addFavoriteFolder.js.map

/***/ }),

/***/ 3331:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var userConfigurationDictionaryEntry_1 = __webpack_require__(116);
var userConfigurationDictionaryObject_1 = __webpack_require__(117);
var updateUserConfiguration_1 = __webpack_require__(153);
function updateFavoritesUserOptionService(newFavoritesNodesRaw) {
    return updateUserConfiguration_1.default('OWA.UserOptions', [
        userConfigurationDictionaryEntry_1.default({
            DictionaryKey: userConfigurationDictionaryObject_1.default({
                Type: 'String',
                Value: ['FavoriteNodes'],
            }),
            DictionaryValue: userConfigurationDictionaryObject_1.default({
                Type: 'StringArray',
                Value: newFavoritesNodesRaw,
            }),
        }),
    ]).then(function (response) {
        var responseItem = response.Body.ResponseMessages.Items[0];
        if (responseItem.ResponseClass == 'Success') {
            return Promise.resolve();
        }
        else {
            return Promise.reject('updateUserConfiguration failed: ' + responseItem.ResponseClass);
        }
    });
}
exports.default = updateFavoritesUserOptionService;
//# sourceMappingURL=updateFavoritesUserOptionService.js.map

/***/ }),

/***/ 3332:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var updateFavoriteFolderRequest_1 = __webpack_require__(3020);
function updateFavoriteFolderOperation(req, options) {
    if (req.request !== undefined && !req.request["__type"]) {
        req.request = updateFavoriteFolderRequest_1.default(req.request);
    }
    return ServiceRequest_1.makeServiceRequest("UpdateFavoriteFolder", req, options);
}
exports.default = updateFavoriteFolderOperation;


/***/ }),

/***/ 3333:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Moves an item in an array located at fromIndex to the position before the toIndex
 * @param arr the array with the element to be moved
 * @param fromIndex item at this index will be moved
 * @param toIndex item will be inserted before this index
 */
function moveDragAndDroppableItem(arr, fromIndex, toIndex) {
    if (fromIndex == toIndex) {
        return;
    }
    // Validate the indices
    if (fromIndex == -1 || toIndex == -1) {
        return;
    }
    // If moving an element down the list, decrement the toIndex since the splice will shift all the elements up
    if (fromIndex < toIndex) {
        toIndex--;
    }
    var itemToMove = arr.splice(fromIndex, 1)[0];
    arr.splice(toIndex, 0, itemToMove);
}
exports.default = moveDragAndDroppableItem;
//# sourceMappingURL=moveDragAndDroppableItem.js.map

/***/ }),

/***/ 3334:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var distinguishedFolderId_1 = __webpack_require__(97);
var findPeopleJsonRequest_1 = __webpack_require__(1561);
var findPeopleRequest_1 = __webpack_require__(1748);
var indexedPageView_1 = __webpack_require__(236);
var personaResponseShape_1 = __webpack_require__(1749);
var targetFolderId_1 = __webpack_require__(156);
var findPeopleOperation_1 = __webpack_require__(1750);
var ServiceRequestUtils_1 = __webpack_require__(31);
var contextProperty_1 = __webpack_require__(2654);
var defaultPageView = {
    BasePoint: 'Beginning',
    Offset: 0,
    MaxEntriesReturned: 10,
};
var defaultShape = {
    BaseShape: 'Default',
};
function configureContext() {
    return [contextProperty_1.default({ Key: 'AppName', Value: 'OWA' })];
}
// Setting SearchPeopleSuggestionIndex to true will resolve the displayName correctly for non-contacts
function createFindPeopleRequest(queryString) {
    return findPeopleRequest_1.default({
        IndexedPageItemView: indexedPageView_1.default(defaultPageView),
        PersonaShape: personaResponseShape_1.default(defaultShape),
        QuerySources: ['Mailbox', 'Directory'],
        QueryString: queryString,
        SearchPeopleSuggestionIndex: true,
        ShouldResolveOneOffEmailAddress: true,
        Context: configureContext(),
    });
}
// Setting SearchPeopleSuggestionIndex to false will return also contacts
// Contacts will be searched in the root folder 'MyContacts'
function createFindContactsRequest(queryString) {
    return findPeopleRequest_1.default({
        IndexedPageItemView: indexedPageView_1.default(defaultPageView),
        PersonaShape: personaResponseShape_1.default(defaultShape),
        QuerySources: ['Mailbox'],
        QueryString: queryString,
        ParentFolderId: targetFolderId_1.default({
            BaseFolderId: distinguishedFolderId_1.default({
                Id: 'mycontacts',
            }),
        }),
        Context: configureContext(),
    });
}
function processResponseMessage(responseMessage, isContact) {
    if (responseMessage.ResponseClass == 'Success') {
        return { personas: responseMessage.ResultSet, requestId: responseMessage.TransactionId };
    }
    throw new Error("FindPeople failed (" + responseMessage.ResponseCode + " " + responseMessage.MessageText + " " + isContact + ")");
}
function findPeopleByEmail(queryString) {
    return findPeopleOperation_1.default(findPeopleJsonRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: createFindPeopleRequest(queryString),
    })).then(function (response) {
        return processResponseMessage(response.Body, false);
    });
}
exports.findPeopleByEmail = findPeopleByEmail;
function findContactsByEmail(queryString) {
    return findPeopleOperation_1.default(findPeopleJsonRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: createFindContactsRequest(queryString),
    })).then(function (response) {
        return processResponseMessage(response.Body, true);
    });
}
exports.findContactsByEmail = findContactsByEmail;
//# sourceMappingURL=findPeopleByEmail.js.map

/***/ }),

/***/ 3335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var getPersonaByEmail_1 = __webpack_require__(3165);
var synchronizeSearchFolder_1 = __webpack_require__(3166);
var datapoints_1 = __webpack_require__(237);
var owa_analytics_1 = __webpack_require__(12);
var owa_guid_1 = __webpack_require__(585);
var store_1 = __webpack_require__(240);
var owa_mail_folder_forest_store_1 = __webpack_require__(53);
var owa_trace_1 = __webpack_require__(14);
var legacy_1 = __webpack_require__(1);
var createDropViewState_1 = __webpack_require__(241);
/**
 * Add a favorite node to the favorite store
 */
var addFavoritePersonaAction = legacy_1.action('AddFavoritePersona', datapoints_1.default.AddFavoritePersonaAction)(function addFavoritePersona(emailAddress, displayName, personaId, actionSource, isRetry) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var favoritesStore, tempPersonaId, initialFavoritePersona, persona, personaIdForEmail_1, favoritePersonaUpdated, index, selectedPersonaNode, error_1, _a, eventName, customData;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    favoritesStore = store_1.getStore();
                    favoritesStore.isFavoritePersonasChangeable = false;
                    tempPersonaId = personaId ? personaId : owa_guid_1.getGuid();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    // Check if favoritesPersonaNodes already has the same persona id
                    if (favoritesStore.favoritesPersonaNodes.has(tempPersonaId)) {
                        throw new Error('Cannot add duplicate personas to favorites. Store has tempId before Persona resolution');
                    }
                    initialFavoritePersona = {
                        id: tempPersonaId,
                        type: 1 /* Persona */,
                        displayName: displayName,
                        mainEmailAddress: emailAddress,
                        allEmailAddresses: [],
                        searchFolderId: undefined,
                        isJustAdded: true,
                        isSyncUpdateDone: true,
                        dropViewState: createDropViewState_1.default(),
                    };
                    // Add to favorite to favorites store, to update the UI with the initial information
                    favoritesStore.orderedFavoritesNodeIds.push(tempPersonaId);
                    favoritesStore.favoritesPersonaNodes.set(tempPersonaId, initialFavoritePersona);
                    return [4 /*yield*/, getPersonaByEmail_1.default(emailAddress, displayName).catch(function (error) {
                            cleanup(tempPersonaId);
                            throw error;
                        })];
                case 2:
                    persona = _b.sent();
                    // Between the add and await the user can potentially have removed the entry
                    if (!favoritesStore.favoritesPersonaNodes.has(tempPersonaId)) {
                        favoritesStore.isFavoritePersonasChangeable = true;
                        return [2 /*return*/];
                    }
                    personaIdForEmail_1 = persona.PersonaId.Id;
                    // Check if favoritesPersonaNodes already has the same persona id
                    if (tempPersonaId !== personaIdForEmail_1 &&
                        favoritesStore.favoritesPersonaNodes.has(personaIdForEmail_1)) {
                        cleanup(tempPersonaId);
                        throw new Error('Cannot add duplicate personas to favorites. Store has personaId after Persona resolution.');
                    }
                    favoritePersonaUpdated = tslib_1.__assign({}, initialFavoritePersona, { id: personaIdForEmail_1, displayName: persona.DisplayName, mainEmailAddress: persona.EmailAddress.EmailAddress, allEmailAddresses: persona.EmailAddresses.map(function (email) { return email.EmailAddress; }), isJustAdded: false });
                    // Add to favorite to favorites store
                    favoritesStore.favoritesPersonaNodes.set(personaIdForEmail_1, favoritePersonaUpdated);
                    // Remove the temp node in case the given the personaId in the parameter was undefined
                    if (tempPersonaId !== personaIdForEmail_1) {
                        favoritesStore.favoritesPersonaNodes.delete(tempPersonaId);
                        index = favoritesStore.orderedFavoritesNodeIds.indexOf(tempPersonaId);
                        if (index > -1) {
                            favoritesStore.orderedFavoritesNodeIds[index] = personaIdForEmail_1;
                        }
                    }
                    selectedPersonaNode = owa_mail_folder_forest_store_1.getSelectedNode();
                    if (selectedPersonaNode.id === personaIdForEmail_1 &&
                        selectedPersonaNode.markedForDeletion) {
                        // A person might be favorited before the search folder is deleted
                        // Remove the markedForDeletion flag
                        selectedPersonaNode.markedForDeletion = false;
                    }
                    // Setup search folder
                    return [4 /*yield*/, synchronizeSearchFolder_1.default(favoritePersonaUpdated).catch(function (error) {
                            cleanup(personaIdForEmail_1);
                            throw error;
                        })];
                case 3:
                    // Setup search folder
                    _b.sent();
                    favoritesStore.isFavoritePersonasChangeable = true;
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    favoritesStore.isFavoritePersonasChangeable = true;
                    _a = datapoints_1.default.AddFavoritePersonaFailure.datapoint, eventName = _a.name, customData = _a.customData;
                    if (isRetry) {
                        // This will log error as well
                        owa_trace_1.trace.error({ message: eventName, error: error_1 });
                    }
                    else {
                        owa_trace_1.trace.warn(eventName + ': ' + error_1);
                    }
                    owa_analytics_1.logUsage(eventName, customData(error_1.toString(), isRetry));
                    throw tslib_1.__assign({ type: 'AddFavoritePersonaError' }, error_1);
                case 5: return [2 /*return*/];
            }
        });
    });
});
function cleanup(personaId) {
    var favoritesStore = store_1.getStore();
    var index = favoritesStore.orderedFavoritesNodeIds.indexOf(personaId);
    if (index > -1) {
        favoritesStore.orderedFavoritesNodeIds.splice(index, 1);
    }
    if (favoritesStore.favoritesPersonaNodes.has(personaId)) {
        favoritesStore.favoritesPersonaNodes.delete(personaId);
    }
}
exports.default = addFavoritePersonaAction;
//# sourceMappingURL=addFavoritePersona.js.map

/***/ }),

/***/ 3336:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var updateFavoritesUserOption_1 = __webpack_require__(2668);
var datapoints_1 = __webpack_require__(237);
var createDropViewState_1 = __webpack_require__(241);
var owa_mail_favorites_store_1 = __webpack_require__(32);
var legacy_1 = __webpack_require__(1);
var isInFavorites_1 = __webpack_require__(688);
/**
 * Add a favorite category from the favorite store
 * @param id of the category
 * @param actionSource where the remove favorite category comes from
 */
exports.default = legacy_1.action('addFavoriteCategory', datapoints_1.default.AddFavoriteCategory)(function addFavoriteCategory(id, actionSource) {
    // Check if category is already in favorites
    if (isInFavorites_1.isCategoryInFavorites(id)) {
        // This function should not be called when duplicate category is added to favorites
        throw new Error('Cannot add duplicate category to favorites.');
    }
    // Add favorite category to favorite store
    owa_mail_favorites_store_1.favoritesStore.orderedFavoritesNodeIds.push(id);
    owa_mail_favorites_store_1.favoritesStore.favoriteCategories.set(id, {
        id: id,
        type: 5 /* Category */,
        treeType: 'favorites',
        dropViewState: createDropViewState_1.default(),
    });
    // Update user options service which is used by OWA
    updateFavoritesUserOption_1.default();
});
//# sourceMappingURL=addFavoriteCategory.js.map

/***/ }),

/***/ 3657:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var updateFavoritesUserOption_1 = __webpack_require__(2668);
var datapoints_1 = __webpack_require__(237);
var owa_analytics_1 = __webpack_require__(12);
var store_1 = __webpack_require__(240);
var owa_mail_persona_search_folder_services_1 = __webpack_require__(163);
var owa_trace_1 = __webpack_require__(14);
var legacy_1 = __webpack_require__(1);
var owa_mail_folder_forest_store_1 = __webpack_require__(53);
/**
 * Add or remove the given personaId from the favorite list
 * @param idToUpdate the id to remove
 * @param state the state which contains the favoritesPersonaNodes and the persona id to update
 */
var removeFavoritePersonaAction = legacy_1.action('removeFavoritePersona', datapoints_1.default.RemoveFavoritePersonaAction)(function removeFavoritePersona(personaId, actionSource, isRetry) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var favoritesStore, persona, searchFolderId, indexOfElementToRemove, selectedPersonaNode, error_1, _a, eventName, customData, error_2, _b, eventName, customData;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    favoritesStore = store_1.getStore();
                    favoritesStore.isFavoritePersonasChangeable = false;
                    persona = favoritesStore.favoritesPersonaNodes.get(personaId);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 9, , 10]);
                    if (!persona) {
                        throw new Error('Cannot find the persona id in favorites list.');
                    }
                    searchFolderId = persona.searchFolderId;
                    indexOfElementToRemove = favoritesStore.orderedFavoritesNodeIds.indexOf(personaId);
                    if (indexOfElementToRemove > -1) {
                        favoritesStore.orderedFavoritesNodeIds.splice(indexOfElementToRemove, 1);
                    }
                    favoritesStore.favoritesPersonaNodes.delete(personaId);
                    return [4 /*yield*/, updateFavoritesUserOption_1.default()];
                case 2:
                    _c.sent();
                    selectedPersonaNode = owa_mail_folder_forest_store_1.getSelectedNode();
                    _c.label = 3;
                case 3:
                    _c.trys.push([3, 7, , 8]);
                    if (!(selectedPersonaNode.id === personaId)) return [3 /*break*/, 4];
                    selectedPersonaNode.markedForDeletion = true;
                    return [3 /*break*/, 6];
                case 4: 
                // If the action comes from LPC or the left nav we delete the folder immediately
                return [4 /*yield*/, owa_mail_persona_search_folder_services_1.deleteFolders([searchFolderId], true /* permanentlyDelete */)];
                case 5:
                    // If the action comes from LPC or the left nav we delete the folder immediately
                    _c.sent();
                    _c.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    error_1 = _c.sent();
                    _a = datapoints_1.default.DeleteFolderFailure.datapoint, eventName = _a.name, customData = _a.customData;
                    owa_trace_1.trace.warn(eventName + ': ' + error_1);
                    owa_analytics_1.logUsage(eventName, customData(error_1.toString()));
                    return [3 /*break*/, 8];
                case 8:
                    favoritesStore.isFavoritePersonasChangeable = true;
                    return [3 /*break*/, 10];
                case 9:
                    error_2 = _c.sent();
                    favoritesStore.isFavoritePersonasChangeable = true;
                    _b = datapoints_1.default.RemoveFavoritePersonaFailure.datapoint, eventName = _b.name, customData = _b.customData;
                    if (isRetry) {
                        // This will log error as well
                        owa_trace_1.trace.error({ message: eventName, error: error_2 });
                    }
                    else {
                        owa_trace_1.trace.warn(eventName + ': ' + error_2);
                    }
                    owa_analytics_1.logUsage(eventName, customData(error_2.toString(), isRetry));
                    // Add back to store if needed
                    if (persona && !favoritesStore.favoritesPersonaNodes.has(persona.id)) {
                        favoritesStore.orderedFavoritesNodeIds.push(persona.id);
                        favoritesStore.favoritesPersonaNodes.set(persona.id, persona);
                    }
                    throw tslib_1.__assign({ type: 'RemoveFavoritePersonaError' }, error_2);
                case 10: return [2 /*return*/];
            }
        });
    });
});
exports.default = removeFavoritePersonaAction;
//# sourceMappingURL=removeFavoritePersona.js.map

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var initialState = {
    notificationViewStates: [],
};
exports.default = satcheljs_1.createStore('headerToastNotificationViewState', initialState)();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
var store_1 = __webpack_require__(366);
exports.default = legacy_1.action('removeNotification')(function removeNotification(notification) {
    var index = store_1.default.notificationViewStates.indexOf(notification);
    if (index >= 0) {
        store_1.default.notificationViewStates.splice(index, 1);
    }
});
//# sourceMappingURL=removeNotification.js.map

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NotificationViewState_1 = __webpack_require__(369);
var removeNotification_1 = __webpack_require__(367);
var notificationHandlers = {};
function ensureNotificationHandlerRegistered(actionType, handler) {
    var actionTypeString = NotificationViewState_1.NotificationActionType[actionType];
    if (!notificationHandlers[actionTypeString]) {
        notificationHandlers[actionTypeString] = handler;
    }
}
exports.ensureNotificationHandlerRegistered = ensureNotificationHandlerRegistered;
function handleNotification(notification) {
    var handler = notificationHandlers[NotificationViewState_1.NotificationActionType[notification.actionType]];
    if (handler) {
        handler(notification);
    }
    removeNotification_1.default(notification);
}
exports.handleNotification = handleNotification;
//# sourceMappingURL=notificationHandler.js.map

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NotificationActionType;
(function (NotificationActionType) {
    NotificationActionType[NotificationActionType["AsyncSendFailed"] = 0] = "AsyncSendFailed";
    NotificationActionType[NotificationActionType["AddFavoritePersonaFailedNotification"] = 1] = "AddFavoritePersonaFailedNotification";
    NotificationActionType[NotificationActionType["RemoveFavoritePersonaFailedNotification"] = 2] = "RemoveFavoritePersonaFailedNotification";
    NotificationActionType[NotificationActionType["PeopleHubNotification"] = 3] = "PeopleHubNotification";
    NotificationActionType[NotificationActionType["SkypeNotification"] = 4] = "SkypeNotification";
})(NotificationActionType = exports.NotificationActionType || (exports.NotificationActionType = {}));
//# sourceMappingURL=NotificationViewState.js.map

/***/ }),

/***/ 4645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(240);
var favoriteNodeParser = __webpack_require__(377);
var favoritesBitFlagsActions = __webpack_require__(700);
var loadFavorites_1 = __webpack_require__(794);
var userConfigurationDictionaryEntry_1 = __webpack_require__(116);
var userConfigurationDictionaryObject_1 = __webpack_require__(117);
var getUserConfiguration_1 = __webpack_require__(9);
var updateUserConfiguration_1 = __webpack_require__(153);
var folderNameToId_1 = __webpack_require__(35);
var legacy_1 = __webpack_require__(1);
/**
 * Update local and server userOptions.FavoriteNodes and userOptions.FavoritesBitFlags
 * @param favoritesStore the favorites store
 * @param userOptions the user options
 */
function updateFavoritesAndMarkMigrationComplete(favoritesStore, userOptions) {
    var newFavoritesNodesRaw = favoriteNodeParser.serialize(favoritesStore.orderedFavoritesNodeIds, favoritesStore.favoritesFolderNodes, favoritesStore.favoritesPersonaNodes, favoritesStore.favoriteSearches, favoritesStore.favoriteCategories);
    // Update the local user configuration store
    userOptions.FavoriteNodes = newFavoritesNodesRaw;
    favoritesBitFlagsActions.setBit(true /* value*/, 2 /* FirstRunFavoritesMigration */);
    // Send out request to update both UserOptions.FavoriteNodes and FavoritesBitFlags
    updateUserConfiguration_1.default('OWA.UserOptions', [
        userConfigurationDictionaryEntry_1.default({
            DictionaryKey: userConfigurationDictionaryObject_1.default({
                Type: 'String',
                Value: ['FavoriteNodes'],
            }),
            DictionaryValue: userConfigurationDictionaryObject_1.default({
                Type: 'StringArray',
                Value: newFavoritesNodesRaw,
            }),
        }),
        userConfigurationDictionaryEntry_1.default({
            DictionaryKey: userConfigurationDictionaryObject_1.default({
                Type: 'String',
                Value: ['FavoritesBitFlags'],
            }),
            DictionaryValue: userConfigurationDictionaryObject_1.default({
                Type: 'Integer32',
                Value: ["" + userOptions.FavoritesBitFlags],
            }),
        }),
    ]);
}
/**
 * Migrate single favorite folder
 * @param folderId the folder to be migrated
 */
function tryMigrateSingleFavoriteFolder(folderId) {
    var favoriteFolderNode = {
        id: folderId,
        type: 0 /* Folder */,
    };
    loadFavorites_1.tryAddSingleFavoriteFolderToStore(favoriteFolderNode);
}
/**
 * Migrate the favorites for the first run experience
 * @param state the MigrateFavoritesState
 */
exports.default = legacy_1.action('migrateFavorites')(legacy_1.select({
    favoritesStore: function () { return store_1.default; },
})(function migrateFavorites(state) {
    var favoritesStore = state.favoritesStore;
    // 1. Automatically populate default folders it they don't exist in favorites
    var defaultFavoriteFolderIds = [
        folderNameToId_1.default('inbox'),
        folderNameToId_1.default('drafts'),
        folderNameToId_1.default('archive'),
    ];
    defaultFavoriteFolderIds.forEach(function (folderId) { return tryMigrateSingleFavoriteFolder(folderId); });
    // 2. Load existing UserOptions.FavoriteNodes to store if there is any
    loadFavorites_1.loadFavoriteNodesToStore(favoritesStore);
    // 3. Migrate de-duped UserOptions.FavoriteFolders(used by JsMVVM) to FavoriteNodes(used by React), if there is any
    var userOptions = getUserConfiguration_1.default().UserOptions;
    if (userOptions.FavoriteFolders) {
        userOptions.FavoriteFolders.forEach(function (folderId) {
            return tryMigrateSingleFavoriteFolder(folderId);
        });
    }
    // 4. Submit the service call to update UserOptions on the client and server
    updateFavoritesAndMarkMigrationComplete(favoritesStore, userOptions);
}));
//# sourceMappingURL=migrateFavorites.js.map

/***/ }),

/***/ 4646:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_favorites_store_1 = __webpack_require__(32);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('markFavoritePersonaNodeAsAdded')(legacy_1.select({
    favoritesPersonaNodes: function () { return owa_mail_favorites_store_1.favoritesStore.favoritesPersonaNodes; },
})(function markFavoritePersonaNodeAsAdded(favoriteId, state) {
    var personaNode = state.favoritesPersonaNodes.get(favoriteId);
    if (personaNode) {
        personaNode.isJustAdded = false;
    }
}));
//# sourceMappingURL=markFavoritePersonaNodeAsAdded.js.map

/***/ }),

/***/ 4647:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var updateFavoritesUserOption_1 = __webpack_require__(2668);
var moveDragAndDroppableItem_1 = __webpack_require__(3333);
var owa_mail_favorites_store_1 = __webpack_require__(32);
var legacy_1 = __webpack_require__(1);
/**
 * Move the favorite node before the specified node
 * @param favoriteIdToUpdate the id to be moved
 * @param destinationFavoriteId the id to be inserted before
 */
exports.default = legacy_1.action('moveFavoriteToPosition')(legacy_1.select({
    orderedFavoritesNodeIds: function () { return owa_mail_favorites_store_1.favoritesStore.orderedFavoritesNodeIds; },
})(function moveFavoriteToPosition(favoriteIdToUpdate, destinationFavoriteId, state) {
    var orderedFavoritesNodeIds = state.orderedFavoritesNodeIds;
    var fromIndex = orderedFavoritesNodeIds.indexOf(favoriteIdToUpdate);
    var toIndex = orderedFavoritesNodeIds.indexOf(destinationFavoriteId);
    // Move the element from the old position to the new position in the array
    moveDragAndDroppableItem_1.default(orderedFavoritesNodeIds, fromIndex, toIndex);
    // Update user options service which is used by OWA
    updateFavoritesUserOption_1.default();
}));
//# sourceMappingURL=moveFavoriteToPosition.js.map

/***/ }),

/***/ 4648:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var updateFavoritesUserOption_1 = __webpack_require__(2668);
var store_1 = __webpack_require__(240);
var legacy_1 = __webpack_require__(1);
/**
 * Swap two elements in the array given the specified indexes
 * @param i the first index
 * @param j the second index
 * @param arr the array
 */
function swap(i, j, arr) {
    var tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
/**
 * Move the favorite up/down in the favorites list
 * @param idToUpdate the folderId to be moved
 * @param isMoveUp whether the operation is move up
 * @param state the state which contains all favorite ids and folder
 */
exports.default = legacy_1.action('moveFavoriteUpDown')(legacy_1.select({
    orderedFavoritesNodeIds: function () { return store_1.default.orderedFavoritesNodeIds; },
})(function moveFavoriteUpDown(nodeId, isMoveUp, state) {
    var orderedFavoritesNodeIds = state.orderedFavoritesNodeIds;
    validateMoveFavorite(nodeId, orderedFavoritesNodeIds, isMoveUp);
    for (var i = 0; i < orderedFavoritesNodeIds.length; i++) {
        if (nodeId == orderedFavoritesNodeIds[i]) {
            var indexToSwap = isMoveUp ? i - 1 : i + 1;
            swap(i, indexToSwap, state.orderedFavoritesNodeIds);
            break;
        }
    }
    // Update user options service which is used by OWA
    updateFavoritesUserOption_1.default();
    // Service request for FAI that used by outlook desktop
    // VSO 14030: Created to track what to do with the FAI
}));
/**
 * Validate the action
 * @param idToUpdate the id to update
 * @param orderedFavoritesNodeIds the orderedFavoritesNodeIds
 * @param isMoveUp whether this is a moveUp action
 */
function validateMoveFavorite(nodeId, orderedFavoritesNodeIds, isMoveUp) {
    // Check if it's the first index if it's a "moveUp" action
    if (isMoveUp && orderedFavoritesNodeIds[0] == nodeId) {
        throw new Error('Move up should not be performed on the first element in the favorites list.');
    }
    // Check if it's the last index the id if it's an "moveDown" action
    if (!isMoveUp && orderedFavoritesNodeIds[orderedFavoritesNodeIds.length - 1] == nodeId) {
        throw new Error('Move down should not be performed on the last element in the favorites list.');
    }
    // Check if favorites doesn't contain the id
    if (orderedFavoritesNodeIds.indexOf(nodeId) < 0) {
        throw new Error("Cannot move a node that's not in favorites list.");
    }
}
//# sourceMappingURL=moveFavoriteUpDown.js.map

/***/ }),

/***/ 4649:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var fetchAndRefreshPersona_1 = __webpack_require__(4650);
var synchronizeSearchFolder_1 = __webpack_require__(3166);
var datapoints_1 = __webpack_require__(237);
var owa_analytics_1 = __webpack_require__(12);
var owa_mail_favorites_store_1 = __webpack_require__(32);
var owa_trace_1 = __webpack_require__(14);
var legacy_1 = __webpack_require__(1);
// When user click on exiting favorite persona we want to update search folder if needed - if emails/display name has changed
exports.default = legacy_1.action('onFavoritePersonaSelected', datapoints_1.default.OnFavoritePersonaSelectedAction)(legacy_1.select({
    favoritesPersonaNodes: function () { return owa_mail_favorites_store_1.favoritesStore.favoritesPersonaNodes; },
})(function onFavoritePersonaSelected(personaId, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var persona, error_1, _a, eventName, customData;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    persona = state.favoritesPersonaNodes.get(personaId);
                    if (!!persona.isSyncUpdateDone) return [3 /*break*/, 5];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetchAndRefreshPersona_1.default(persona.id, persona.mainEmailAddress, persona.displayName)];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, synchronizeSearchFolder_1.default(persona)];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    _a = datapoints_1.default.UpdatePersonaAndSearchFolderFailure.datapoint, eventName = _a.name, customData = _a.customData;
                    owa_trace_1.trace.warn(eventName + ': ' + error_1);
                    owa_analytics_1.logUsage(eventName, customData(error_1.toString()));
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=onFavoritePersonaSelected.js.map

/***/ }),

/***/ 4650:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var getPersonaByEmail_1 = __webpack_require__(3165);
var owa_mail_favorites_store_1 = __webpack_require__(32);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('fetchAndRefreshPersona')(function fetchAndRefreshPersona(currentPersonaId, currentPersonaEmail, currentDisplayName) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var state, persona, favoritePersona, newDisplayName, newMainEmailAddress, newAllEmailAddresses;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = owa_mail_favorites_store_1.getStore();
                    return [4 /*yield*/, getPersonaByEmail_1.default(currentPersonaEmail, currentDisplayName)];
                case 1:
                    persona = _a.sent();
                    favoritePersona = state.favoritesPersonaNodes.get(currentPersonaId);
                    if (favoritePersona) {
                        newDisplayName = persona.DisplayName;
                        newMainEmailAddress = persona.EmailAddress.EmailAddress;
                        newAllEmailAddresses = persona.EmailAddresses.map(function (email) { return email.EmailAddress; });
                        if (favoritePersona.displayName !== newDisplayName ||
                            favoritePersona.mainEmailAddress !== newMainEmailAddress ||
                            !hasSameItems(favoritePersona.allEmailAddresses, newAllEmailAddresses)) {
                            state.haveFavoritePersonasChanged = true;
                            updatePersona(favoritePersona, newDisplayName, newMainEmailAddress, newAllEmailAddresses);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
});
// This is extracted to separate function due to bug in Satchel which occurs in tests:
// [mobx] Invariant failed: It is not allowed to create or change state outside an `action` when MobX is in strict mode.
var updatePersona = legacy_1.action('updatePersona')(function updatePersona(favoritePersona, newDisplayName, newMainEmailAddress, newAllEmailAddresses) {
    favoritePersona.displayName = newDisplayName;
    favoritePersona.mainEmailAddress = newMainEmailAddress;
    favoritePersona.allEmailAddresses = newAllEmailAddresses;
});
function hasSameItems(left, right) {
    return (left &&
        right &&
        left.length === right.length &&
        left.every(function (element) { return right.includes(element); }));
}
//# sourceMappingURL=fetchAndRefreshPersona.js.map

/***/ }),

/***/ 4651:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var datapoints_1 = __webpack_require__(237);
var owa_analytics_1 = __webpack_require__(12);
var owa_mail_persona_search_folder_services_1 = __webpack_require__(163);
var owa_trace_1 = __webpack_require__(14);
/**
 * If the currenly selected persona get un-favorited we cannot delete the search folder
 * immediately, but once the selected node changes.
 */
function onSelectedPersonaNodeChanged(personaNode) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var error_1, _a, eventName, customData;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    if (!personaNode.markedForDeletion) return [3 /*break*/, 2];
                    return [4 /*yield*/, owa_mail_persona_search_folder_services_1.deleteFolders([personaNode.searchFolderId], true /* permanentlyDelete */)];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    _a = datapoints_1.default.DeleteFolderFailure.datapoint, eventName = _a.name, customData = _a.customData;
                    owa_trace_1.trace.warn(eventName + ': ' + error_1);
                    owa_analytics_1.logUsage(eventName, customData(error_1.toString()));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.default = onSelectedPersonaNodeChanged;
//# sourceMappingURL=onSelectedPersonaNodeChanged.js.map

/***/ }),

/***/ 4652:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getFavoritePersonaByEmail_1 = __webpack_require__(4653);
var isInFavorites_1 = __webpack_require__(688);
var addFavoritePersona_1 = __webpack_require__(3335);
var removeFavoritePersona_1 = __webpack_require__(3657);
var datapoints_1 = __webpack_require__(237);
var owa_analytics_1 = __webpack_require__(12);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('toggleFavoritePersona', datapoints_1.default.ToggleFavoritePersona)(function toggleFavoritePersona(personaId, emailAddress, displayName, actionSource) {
    if (isInFavorites_1.isPersonaInFavorites(personaId, emailAddress)) {
        if (!personaId) {
            // We are removing favorite from search results header or LPC in which we don't have personaId
            var favoritePersona = getFavoritePersonaByEmail_1.default(emailAddress);
            if (favoritePersona) {
                personaId = getFavoritePersonaByEmail_1.default(emailAddress).id;
            }
            else {
                var _a = datapoints_1.default.RemoveFavoritePersonaFailure.datapoint, eventName = _a.name, customData = _a.customData;
                owa_analytics_1.logUsage(eventName, customData(emailAddress ? 'EmailAddressNotFound' : 'EmailAddressMissing', false));
            }
        }
        return removeFavoritePersona_1.default(personaId, actionSource);
    }
    else {
        return addFavoritePersona_1.default(emailAddress, displayName, personaId, actionSource);
    }
});
//# sourceMappingURL=toggleFavoritePersona.js.map

/***/ }),

/***/ 4653:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_favorites_store_1 = __webpack_require__(32);
function getFavoritePersonaByEmail(emailAddress) {
    var personas = owa_mail_favorites_store_1.favoritesStore.favoritesPersonaNodes
        .values()
        .filter(function (node) {
        return node.mainEmailAddress &&
            node.mainEmailAddress.toLowerCase() === emailAddress.toLowerCase();
    });
    if (personas && personas.length > 0) {
        return personas[0];
    }
    return undefined;
}
exports.default = getFavoritePersonaByEmail;
//# sourceMappingURL=getFavoritePersonaByEmail.js.map

/***/ }),

/***/ 4654:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
var owa_mail_strings_1 = __webpack_require__(22);
var owa_header_toast_notification_1 = __webpack_require__(1610);
exports.default = legacy_1.action('handleToggleFavoritePersonaError')(function handleToggleFavoritePersonaError(error, retryFunction) {
    var isAddFailure = error.type === 'AddFavoritePersonaError';
    var notificationType = isAddFailure
        ? owa_header_toast_notification_1.NotificationActionType.AddFavoritePersonaFailedNotification
        : owa_header_toast_notification_1.NotificationActionType.RemoveFavoritePersonaFailedNotification;
    owa_header_toast_notification_1.ensureNotificationHandlerRegistered(notificationType, function () { return retryFunction(); });
    var notification = {
        actionType: notificationType,
        title: isAddFailure
            ? owa_mail_strings_1.default.favoritesErrorTitleText
            : owa_mail_strings_1.default.favoritesRemoveErrorTitleText,
        description: isAddFailure
            ? owa_mail_strings_1.default.favoritesErrorDescriptionText
            : owa_mail_strings_1.default.favoritesRemoveErrorDescriptionText,
        actionLink: owa_mail_strings_1.default.favoritesErrorTryAgainButtonText,
        cancelLink: owa_mail_strings_1.default.favoritesErrorCloseButtonText,
    };
    owa_header_toast_notification_1.addNotification(notification);
});
//# sourceMappingURL=handleToggleFavoritePersonaError.js.map

/***/ }),

/***/ 4655:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var updateFavoritesUserOption_1 = __webpack_require__(2668);
var datapoints_1 = __webpack_require__(237);
var owa_mail_favorites_store_1 = __webpack_require__(32);
var legacy_1 = __webpack_require__(1);
/**
 * Remove a favorite category from the favorite store
 * @param id of the category
 * @param actionSource where the remove favorite category comes from
 */
exports.default = legacy_1.action('removeFavoriteCategory', datapoints_1.default.RemoveFavoriteCategory)(function removeFavoriteCategory(id, actionSource) {
    // Check if favoriteCategories doesn't contain the category
    if (!owa_mail_favorites_store_1.favoritesStore.favoriteCategories.has(id)) {
        throw new Error('Cannot find the category in favorite category list.');
    }
    // Remove favorite from the store
    owa_mail_favorites_store_1.favoritesStore.orderedFavoritesNodeIds.splice(owa_mail_favorites_store_1.favoritesStore.orderedFavoritesNodeIds.indexOf(id), 1);
    owa_mail_favorites_store_1.favoritesStore.favoriteCategories.delete(id);
    // Update user options service which is used by OWA
    updateFavoritesUserOption_1.default();
});
//# sourceMappingURL=removeFavoriteCategory.js.map

/***/ }),

/***/ 4656:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var recentlyRemovedFavorite_1 = __webpack_require__(797);
var updateFavoritesUserOption_1 = __webpack_require__(2668);
var datapoints_1 = __webpack_require__(237);
var addRemoveFavoriteService_1 = __webpack_require__(3164);
var store_1 = __webpack_require__(240);
var Store_1 = __webpack_require__(17);
var legacy_1 = __webpack_require__(1);
/**
 * Add or remove the given folderId from the favorite folder list
 * @param idToUpdate the id to remove
 * @param state the state which contains the favoritesFolderNodes and the folder to update
 */
exports.default = legacy_1.action('removeFavoriteFolder', datapoints_1.default.RemoveFavoriteFolder)(legacy_1.select({
    favoritesFolderNodes: function () { return store_1.default.favoritesFolderNodes; },
    orderedFavoritesNodeIds: function () { return store_1.default.orderedFavoritesNodeIds; },
    folder: function (idToUpdate, isAdd) { return Store_1.default.folders.folderTable.get(idToUpdate); },
})(function removeFavorite(idToUpdate, actionSource, state) {
    // Check if favoritesFolderNodes doesn't contain the id
    if (!state.favoritesFolderNodes.has(idToUpdate)) {
        throw new Error('Cannot find the folder id in favorite folder list.');
    }
    // Remove from favorite from the store
    state.orderedFavoritesNodeIds.splice(state.orderedFavoritesNodeIds.indexOf(idToUpdate), 1);
    state.favoritesFolderNodes.delete(idToUpdate);
    // Update user options service which is used by OWA
    updateFavoritesUserOption_1.default();
    // Record the last removed folder so we can correlate accidental removes
    recentlyRemovedFavorite_1.recordLastRemoveFavorite(idToUpdate);
    // Service request for FAI that used by outlook desktop
    addRemoveFavoriteService_1.default(state.folder, false /* isAdd */);
}));
//# sourceMappingURL=removeFavoriteFolder.js.map

/***/ }),

/***/ 4657:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var updateFavoritesUserOption_1 = __webpack_require__(2668);
var datapoints_1 = __webpack_require__(237);
var owa_mail_favorites_store_1 = __webpack_require__(32);
var legacy_1 = __webpack_require__(1);
/**
 * Remove a favorite search to the favorite store
 */
exports.default = legacy_1.action('RemoveFavoriteSearch', datapoints_1.default.RemoveFavoriteSearch)(function removeFavoriteSearch(searchQuery, actionSource) {
    // Check if favoriteSearches doesn't contain the search query
    if (!owa_mail_favorites_store_1.favoritesStore.favoriteSearches.has(searchQuery)) {
        throw new Error('Cannot find the search query in favorite search list.');
    }
    // Remove favorite from the store
    owa_mail_favorites_store_1.favoritesStore.orderedFavoritesNodeIds.splice(owa_mail_favorites_store_1.favoritesStore.orderedFavoritesNodeIds.indexOf(searchQuery), 1);
    owa_mail_favorites_store_1.favoritesStore.favoriteSearches.delete(searchQuery);
    // Update user options service which is used by OWA
    updateFavoritesUserOption_1.default();
});
//# sourceMappingURL=removeFavoriteSearch.js.map

/***/ }),

/***/ 4658:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var userConfigurationDictionaryEntry_1 = __webpack_require__(116);
var userConfigurationDictionaryObject_1 = __webpack_require__(117);
var getUserConfiguration_1 = __webpack_require__(9);
var updateUserConfiguration_1 = __webpack_require__(153);
var legacy_1 = __webpack_require__(1);
/**
 * Expand or collapse the Favorites tree ty setting the store isExpand value
 */
exports.default = legacy_1.action('toggleFavoritesTreeExpansion')(function toggleFavoritesTreeExpansion() {
    var userOptions = getUserConfiguration_1.default().UserOptions;
    userOptions.IsFavoritesFolderTreeCollapsed = !userOptions.IsFavoritesFolderTreeCollapsed;
    updateUserConfiguration_1.default('OWA.UserOptions', [
        userConfigurationDictionaryEntry_1.default({
            DictionaryKey: userConfigurationDictionaryObject_1.default({
                Type: 'String',
                Value: ['IsFavoritesFolderTreeCollapsed'],
            }),
            DictionaryValue: userConfigurationDictionaryObject_1.default({
                Type: 'Boolean',
                Value: [String(userOptions.IsFavoritesFolderTreeCollapsed)],
            }),
        }),
    ]);
});
//# sourceMappingURL=toggleFavoritesTreeExpansion.js.map

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}
function getGuid() {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}
exports.getGuid = getGuid;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var removeNotification_1 = __webpack_require__(367);
var notificationHandler_1 = __webpack_require__(368);
var React = __webpack_require__(3);
var BaseToast = /** @class */ (function (_super) {
    tslib_1.__extends(BaseToast, _super);
    function BaseToast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onActionClick = function (e) {
            e.stopPropagation();
            notificationHandler_1.handleNotification(_this.props.notification);
        };
        _this.onCancelClick = function (e) {
            e.stopPropagation();
            removeNotification_1.default(_this.props.notification);
        };
        return _this;
    }
    return BaseToast;
}(React.Component));
exports.default = BaseToast;
//# sourceMappingURL=BaseToast.js.map

/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(1618);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ })

});


// WEBPACK FOOTER //
// owa.FavoritesStore.js